import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { useAuth } from '../context/AuthContext';

const LABELS = {
    all: 'All Employees',
    units: 'Your Unit',
    teams: 'Your Team',
    self: 'Your Data Only',
    'n/a': 'Not Authorized',
};

// Shows the caller what slice of data they're looking at for a given
// feature, resolved the same way the API resolves it server-side.
export default function ScopeBadge({ featureKey }) {
    const { accessLevel } = useAuth();
    const level = accessLevel(featureKey);
    const isDenied = level === 'n/a';
    return (
        <Tooltip title="Based on your role's privileges">
            <Chip
                label={LABELS[level] || LABELS['n/a']}
                size="small"
                variant="outlined"
                sx={{
                    borderColor: isDenied ? 'rgba(239,68,68,0.4)' : 'rgba(255,255,255,0.15)',
                    color: isDenied ? '#EF4444' : 'text.secondary',
                }}
            />
        </Tooltip>
    );
}
